module.exports = __webpack_public_path__ + "static/img/tab2-active.123798fe.png";